module.exports = __webpack_public_path__ + "static/img/loding.8d8cce8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Vcar_result/loding.png
// module id = 7FR6
// module chunks = 19